<ng-container *ngIf="authenticatedUser?.expertise('guru')">
	<span *ngIf="style == 'mat-label'">🟥 GURUs ONLY</span>
	<span *ngIf="style == 'h6'">🟥 GURUs ONLY</span>
</ng-container>